<template>
  <aside class="col-lg-5 col-xl-4  d-none d-sm-none d-md-block">
    <!-- sidebar-login -->
    <side-bar-login v-if="!logeados"></side-bar-login>
    
    <user-menu-side v-if="logeados"></user-menu-side>
    <!-- sidebar-expos -->
    <side-bar-expos></side-bar-expos>
    <hr>
    <side-bar-patrocinador></side-bar-patrocinador>
  </aside>
</template>
<script>
import { mapState, mapActions } from "vuex";
import UserMenuSide from "../users/User-menu-side.vue"
import SideBarLogin from "./Sidebar-login.vue"
import SideBarExpos from "./Sidebar-expos.vue"
import SideBarPatrocinador from "./Side-patrocinador.vue";

export default {
    name : 'Sidebar',
    components : {
        SideBarLogin,
        SideBarExpos,
        UserMenuSide,
        SideBarPatrocinador
    },
    data() {
      return {
        //loggedIn : this.isLoggedIn,
      }
    },
    computed: { 
      ...mapState("account", ["status"]),
       logeados() {
        return this.status.loggedIn;
      }  
     
    }, 
    methods: {
      ...mapActions("account", ["isLoggedIn", "prueba"])
      
    },    
    mounted() {       
     
    }    
}
</script>

